module.exports = __webpack_public_path__ + "static/media/logo-whitee.92d2891d.svg";